import { memo } from 'react';

import { ListTodoIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Tooltip } from '@air/primitive-tooltip';

export const WORKSPACE_AGENT_START_NEW_TASK_DISABLED_TOOLTIP = 'New threads cannot be created';

export type WorkspaceAgentPanelMyTasksFooterProps = {
  isDisabled?: boolean;
  onStartNewTask: () => void;
};

export const WorkspaceAgentPanelMyTasksFooter = memo(
  ({ isDisabled = false, onStartNewTask }: WorkspaceAgentPanelMyTasksFooterProps) => {
    const startNewTaskButton = (
      <Button
        appearance="ghost"
        aria-disabled={isDisabled}
        color="gray"
        data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_START_NEW_TASK"
        onClick={onStartNewTask}
        prefix={<ListTodoIcon aria-hidden className="shrink-0" size="xs" />}
        size="small"
        type="button"
      >
        Start new task
      </Button>
    );

    return (
      <footer
        className="flex min-h-[52px] shrink-0 items-center ads:border-default border-gray-4 border-t bg-inherit px-2.5"
        data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_FOOTER"
      >
        {isDisabled ? (
          <Tooltip
            delayDuration={0}
            data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_START_NEW_TASK_TOOLTIP"
            label={WORKSPACE_AGENT_START_NEW_TASK_DISABLED_TOOLTIP}
          >
            {startNewTaskButton}
          </Tooltip>
        ) : (
          startNewTaskButton
        )}
      </footer>
    );
  },
);

WorkspaceAgentPanelMyTasksFooter.displayName = 'WorkspaceAgentPanelMyTasksFooter';
